import { render, staticRenderFns } from "./VerDetalleEnvioInformacionModal.vue?vue&type=template&id=ca84c802&"
import script from "./VerDetalleEnvioInformacionModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleEnvioInformacionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports